import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {UserResignation} from "../user-resignation.model";

export class UserResignationDgSearchResults extends GenericDgSearchResults {
  public results: UserResignation[];

  constructor(total: number, results: UserResignation[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

